"use client";
import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { WebinarMeta } from "@/components/webinar/webinar-meta";
import { PriceLink } from "@/components/ecommerce/price-link";
import { logEvent } from "@/service/logs/log";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { cn } from "@/lib/utils";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { ImageHoverWrapper } from "@/components/common/image-hover-wrapper";
import { webinarRegister } from "@/service/webinar-register";

export const WebinarCard = ({
  webinar: { slug, image, title, start, end, product },
  instantImageLoaded = false,
  isLive = false,
  aside = false,
}: {
  webinar: WebinarPreviewVM;
  instantImageLoaded?: boolean;
  isLive?: boolean;
  aside?: boolean;
}) => {
  const { logView } = useContext(ResourceContext);

  async function signIn(e) {
    if (isLive) {
      e.preventDefault();
      e.stopPropagation();
      try {
        const { url } = await webinarRegister(slug);
        logEvent("live_webinar_click", logView, {
          resource_title: title,
          resource_path: createPath("webinar.show", { slug }),
        });

        window.location.href = url;
      } catch (error: { message: string }) {
        console.log(errror);
      }
    }
  }

  return (
    <div>
      <ImageHoverWrapper
        className={cn(
          "relative mb-4 overflow-hidden rounded-xl",
          aside && "xl:mb-2 xl:rounded-lg",
        )}
        rounded={cn("rounded-xl", aside && "xl:rounded-lg")}
      >
        <Link href={createPath("webinar.show", { slug })} onClick={signIn}>
          <PictureUpload
            image={image}
            loaded={instantImageLoaded}
            aspectRatio={"1.91 / 1"}
            type={"card"}
          />
        </Link>
      </ImageHoverWrapper>

      <div
        className={cn(
          "mb-2 min-h-6 text-base font-[550] text-zinc-800",
          aside && "xl:text-sm",
        )}
      >
        <Link
          href={createPath("webinar.show", { slug })}
          onClick={signIn}
          className={"text-remedium-blue-hover"}
        >
          {title}
        </Link>
      </div>

      <div className={"flex min-h-6 items-center"}>
        <WebinarMeta start={start} end={end} isLive={isLive} title={title} />
      </div>

      {product && (
        <PriceLink
          product={product}
          link={createPath("webinar.show", { slug })}
        />
      )}
    </div>
  );
};
